<template>
  <div>
    <user-detail-title
      first-bread="发展历程"
      second-bread="发展历程查看"
      first-url="/user/develop"
      title-name="发展历程查看"
    ></user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="年份">
          <span>{{LookData.year}}</span>
        </el-form-item>
        <el-form-item label="图片">
          <img class="item-image" :src="'http://'+LookData.address" alt="">
        </el-form-item>
        <el-form-item label="描述">
          <pre>
            {{LookData.description}}
          </pre>
        </el-form-item>
        <el-form-item label="创建时间">
          <span>{{LookData.createTime}}</span>
        </el-form-item>
        <el-form-item label="更新时间">
          <span>{{LookData.updateTime}}</span>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "DevelopLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/develop/getById',{params:{
          id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>
.item-image{
  height: 40px;
  width: auto;
  object-fit: cover;
}
</style>